export function maker(text = '가') {
  return text
    ? (text[text.length - 1].charCodeAt() - 44032) % 28 === 0
    : '';
}
